<div class="main-container">
    <div class="video-wrap flex-center">
        <iframe frameborder="0" [src]="videoLink" webkitallowfullscreen mozallowfullscreen allowfullscreen
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture">
        </iframe>
    </div>
    <i class="uil uil-times close-overlay" (click)="close()"></i>
</div>